module.exports = __webpack_public_path__ + "static/img/ftxl.78aac12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/ftxl.png
// module id = oUNE
// module chunks = 0